import './customer-support.scss';

/**
 * version    1.0
 * class      <type> (customer support)
 * classdesc  Component that manage customer-support
 */
export class CustomerSupport {}
